import React, { Component } from 'react';
import '../node_modules/materialize-css/dist/css/materialize.min.css';
import '../node_modules/materialize-css/dist/js/materialize.min.js';

import './App.css';



import Home from './components/home';
import WeddingTile from './components/WeddingTile';
import MakeoverTile from './components/MakeoverTile';
import MakehairTile from './components/MakehairTile';
import PricingPage from './components/pricingPage'

import {BrowserRouter, Route} from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <div>
      <BrowserRouter>
      <div>
      <Route exact path="/wedding" component = {WeddingTile} />
      <Route exact path="/makeover" component = {MakeoverTile} />
      <Route exact path="/makehair" component = {MakehairTile} />
      <Route exact path="/pricing" component = {PricingPage} />
      <Route exact path="/" component = {Home} />
      <Route exact path="/#work" component = {Home} />
      </div>
      </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js